var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import ButtonIcon from '../icon/ButtonIcon';
import { mdiClose } from '@mdi/js';
import { COLORS } from '../color';
var Drawer = /** @class */ (function (_super) {
    __extends(Drawer, _super);
    function Drawer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Drawer.prototype.componentDidMount = function () {
        var onClose = this.props.onClose;
        window.addEventListener('keyup', function (e) {
            if (e.key === 'Escape') {
                onClose();
            }
        });
    };
    Drawer.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, name = _a.name, right = _a.right, onClose = _a.onClose;
        return (React.createElement("div", null,
            React.createElement("section", { className: 'drawer ' + (isOpen ? 'open' : '') + (right ? ' right' : '') },
                React.createElement("div", { className: 'drawer-header' },
                    React.createElement("h5", { className: 'mb-0' }, name),
                    React.createElement(ButtonIcon, { iconPath: mdiClose, color: COLORS.black, size: 'md', title: 'Закрыть', onClick: onClose })),
                React.createElement("div", null, this.props.children)),
            isOpen && React.createElement("div", { className: 'drawer-fade', onClick: onClose })));
    };
    return Drawer;
}(Component));
export default Drawer;
//# sourceMappingURL=Drawer.js.map